import {
  Component,
  OnInit,
  AfterViewInit,
  Renderer2,
  ElementRef,
} from "@angular/core";
import {
  DomSanitizer,
  SafeResourceUrl,
  SafeUrl,
} from "@angular/platform-browser";
import { Router } from "@angular/router";
import { GetSalesforceDataService } from "app/services/salesforce-data";
import { SalesforceMapperService } from "app/services/salesforce-mapper.service";
import confetti from "canvas-confetti";

@Component({
  selector: "app-home-landing",
  templateUrl: "./home-landing.component.html",
  styleUrls: ["./home-landing.component.scss"],
})
export class HomeLandingComponent implements OnInit, AfterViewInit {
  organizations: any[] = [];
  showWelcomeModal: boolean = false;
  programs: any[] = [];
  categories: any[] = [];

  constructor(
    private _router: Router,
    private renderer: Renderer2,
    private el: ElementRef,
    private _getSalesforceDataService: GetSalesforceDataService,
    private salesforceMapper: SalesforceMapperService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    const cachedCategories = localStorage.getItem("cachedCategoriesData");
    if (cachedCategories) {
      const parsedCache = JSON.parse(cachedCategories);
      this.categories = parsedCache.data;
    }
    const cachedData = localStorage.getItem("cachedOrganizationData");
    if (cachedData) {
      const parsedCache = JSON.parse(cachedData);
      this.organizations = parsedCache.data;
    }
    this.getDataFromSalesforce();
    if (!localStorage.getItem("welcomeShown")) {
      this.showWelcomeModal = true;
      localStorage.setItem("welcomeShown", "true");
    }
    setInterval(() => {
      this.getDataFromSalesforce();
    }, 20 * 60 * 1000);
  }
  getDataFromSalesforce() {
    this._getSalesforceDataService.getDataFromSalesforce1().subscribe(
      (response) => {
        if (response.success) {
          const dataSet = JSON.parse(response.msg);
          const progs = dataSet.data.lstPrograms || [];
          const orgs = dataSet.data.lstOrganizations || [];
          const cats = dataSet.data.lstCategories || [];

          this.programs = this.salesforceMapper.mapPrograms(progs);
          this.organizations = this.salesforceMapper.mapOrganizations(orgs);
          this.categories = this.salesforceMapper.mapCategories(cats);

          localStorage.setItem(
            "cachedProgramsData",
            JSON.stringify({ timestamp: Date.now(), data: this.programs })
          );
          localStorage.setItem(
            "cachedOrganizationData",
            JSON.stringify({ timestamp: Date.now(), data: this.organizations })
          );
          localStorage.setItem(
            "cachedCategoriesData",
            JSON.stringify({ timestamp: Date.now(), data: this.categories })
          );
        }
      },
      (error) => {
        console.error("❌ Salesforce API Error:", error);
        this._getSalesforceDataService.redirectUserToMaintenancePage();
      }
    );
  }
  getSafeUrl(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  ngAfterViewInit(): void {
    this.setupScrollAnimations();
  }

  closeModal(): void {
    confetti({
      particleCount: 150,
      spread: 80,
      origin: { y: 0.6 },
    });

    setTimeout(() => {
      this.showWelcomeModal = false;
    }, 1000);
  }

  home(): void {
    this._router.navigate(["home-landing"]);
  }
  goToExplorePrograms(orgId: string) {
    this._router.navigate(["/explore-programs"], {
      queryParams: { orgId },
    });
  }
  // Animations
  setupScrollAnimations(): void {
    const animateElements = this.el.nativeElement.querySelectorAll(
      ".animate-fade-in-up, .animate-fade-in-left, .animate-fade-in-right"
    );

    const observer = new IntersectionObserver(
      (entries: IntersectionObserverEntry[]) => {
        entries.forEach((entry: IntersectionObserverEntry) => {
          if (entry.isIntersecting) {
            const target = entry.target as HTMLElement;
            this.renderer.setStyle(target, "opacity", "1");
            this.renderer.addClass(target, "animate");
          }
        });
      },
      { threshold: 0.1 }
    );

    animateElements.forEach((element: HTMLElement) => {
      observer.observe(element);
    });
  }
}
